import {
  fetchScheduleCard,
  getScheduleInfoKey
} from '@api/fetchers/test-series';
import useFetch from '@hooks/useFetch';
import { useRouter } from 'next/router';
import { emptyList } from '@constants/empty';
import { readCookie } from '@utils/cookies';
import { useEffect, useRef, useState } from 'react';
import useIntersection from '@hooks/useIntersection';
import { processScheduleCardInfo } from './utils';

const useInfiniteCards = () => {
  const {
    query: { courseUID }
  } = useRouter();

  const [cardsList, setCardsList] = useState([]);
  const [programmeType, setProgrammeType] = useState(null);
  const { intersecting, ref } = useIntersection();

  const scheduleCardKey = getScheduleInfoKey(courseUID);
  const { data: cardsData, mutate } = useFetch(scheduleCardKey);

  const dateMap = useRef({});
  const nextRef = useRef(null);
  const fetchRef = useRef(false);

  useEffect(() => {
    setCardsList(cardsData?.cardsByDate ?? emptyList);
    nextRef.current = cardsData?.next;
    dateMap.current = cardsData?.dateMap;
    if (cardsData?.programmeType != null) {
      setProgrammeType(cardsData.programmeType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    mutate().then((resp) => {
      const processedScheduleInfo = processScheduleCardInfo(resp);
      setCardsList(processedScheduleInfo?.cardsByDate ?? emptyList);
      nextRef.current = processedScheduleInfo?.next;
      dateMap.current = processedScheduleInfo?.dateMap;
      if (processedScheduleInfo?.programmeType != null) {
        setProgrammeType(processedScheduleInfo.programmeType);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (intersecting) {
      if (!fetchRef.current && nextRef.current) {
        fetchRef.current = true;
        const accessToken = readCookie('accessToken');

        fetchScheduleCard(courseUID, nextRef.current, accessToken).then(
          (resp) => {
            const processedInfo = processScheduleCardInfo(
              resp,
              dateMap.current
            );
            fetchRef.current = false;
            nextRef.current = processedInfo?.next;
            dateMap.current = processedInfo.dateMap;

            if (processedInfo?.cardsByDate) {
              setCardsList(processedInfo.cardsByDate);
              if (processedInfo?.programmeType != null) {
                setProgrammeType(processedInfo.programmeType);
              }
            }
          }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intersecting]);

  return {
    ref,
    cardsList,
    programmeType
  };
};

export default useInfiniteCards;
